import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { Button, Form } from 'react-bootstrap';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { GetResource, UpdateResource, addfaq } from '../../actions/users';
import { isEmpty } from '../../actions/commonFunction';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa6';


const initialFormValue = {
    'question': "",
    'answer': "",

}

var array = undefined;

const ResourceUpdate = () => {


    const navigate = useNavigate();
    const { resourceid } = useParams();


    const [FaqArray, SetFaqArray] = useState({});
    const [FaqAnswer, SetFaqAnswer] = useState([]);
    const [validateError, setValidateError] = useState({});
    


    const getFaqData = async () => {
        var test = await GetResource({ id: resourceid });
        let formdata = {};
        
        if (test && test.status) {
            test.data.FaqArray = test?.data?.FaqArray?.length > 0 ? test?.data?.FaqArray : [{ Question: '', Answer: ' ' }];
            SetFaqArray({ ...(test?.data ? test?.data : {}) })
            SetFaqAnswer([...(test?.data?.FaqArray ? test?.data?.FaqArray : [])]);

            array = (test?.data?.FaqArray ? test?.data?.FaqArray : []);
        }
        //setUser(test.userValue);
    }

    useEffect(() => {
        getFaqData();
    }, [])

    const AddFaq = () => {
        SetFaqArray({ ...FaqArray, ...{ FaqArray: [...FaqArray?.FaqArray, ...[{ Question: '', Answer: ' ' }]] } })
        SetFaqAnswer([...FaqAnswer, ...[{ Question: '', Answer: ' ' }]])
        array.push({ Question: '', Answer: ' ' })
    }

    const RemoveFaq = (index) => {
        
        SetFaqArray({ ...FaqArray, ...{ FaqArray: [...FaqArray?.FaqArray.slice(0, index), ...FaqArray?.FaqArray.slice(index+1, FaqArray?.FaqArray?.length)] } })
        SetFaqAnswer([...FaqAnswer.slice(0, index), ...FaqAnswer.slice(index+1, FaqAnswer?.length)])
        array.splice(index, 1)
    }

    const OnChange = (e, ind, type) => {
        
        if (type == "Question") {
            SetFaqArray(
                {
                    ...FaqArray,
                    ...{
                        FaqArray: [
                            ...FaqArray?.FaqArray.slice(0, ind),
                            ...[{ ...FaqArray.FaqArray[ind], ...{ [e?.target?.id]: e?.target?.value } }],
                            ...FaqArray?.FaqArray.slice(ind + 1, FaqArray?.FaqArray?.length)]
                    }
                })
        }
        else if (type == "Answer") {

            SetFaqAnswer(
                [
                    ...FaqAnswer?.slice(0, ind),
                    ...[{ Answer: e }],
                    ...FaqAnswer?.slice(ind + 1, FaqAnswer?.length)]
            )
            array[ind] = { ...array[ind], Answer: e }
        }
        
    }

    const Validate = () => {
        let error = {}
        if (FaqArray?.FaqArray?.length == 0) {
            error.EnterFaq = "Add Faq";
        }
        else {
            FaqArray.FaqArray.map((val, ind) => {
                
                if (val?.Question == '' || val?.Question == undefined || val?.Question == null) {
                    error['Question' + ind] = "Enter Question"

                }
                if (array[ind]?.Answer?.trim() == '' || array[ind]?.Answer == undefined || array[ind]?.Answer == null) {
                    error['Answer' + ind] = "Enter Answer"

                }
            });
        }
        return error;
    }

    const updateData = async () => {
        let error = Validate();
        
        if (Object.keys(error)?.length > 0) {
            setValidateError(error)
            toast.error('Fix all Mistakes')
        }
        else {
            let senddata = FaqArray
            senddata.FaqArray.map((val, ind) => {
                val.Answer = array[ind]?.Answer
            })
            
            let Resp = await UpdateResource(FaqArray);
            
            if (Resp?.status) {
                toast.success('Updated Successfully')
                navigate('/Cms')
            }
            else {
                toast.success('Error Occured')
            }
        }

    }

    return (
        <Layout>
            <div className="faqadd">
                <Link to="/Cms" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">{FaqArray?.Heading}</h1>

               <div className='text-end'><Button type="button" color="primary" className="mb-4"  onClick={()=>AddFaq()}>Add Faq</Button></div> 
                <div className="cardbox">
                    {FaqArray?.FaqArray?.length > 0 ?
                        FaqArray?.FaqArray?.map((val, index) => {
                            return (
                                <>
                                <div className="cardbox mb-4">
                                    <Form>
                                        <Form.Label>Question</Form.Label>
                                        <Form.Control type="text" placeholder="Question" className="w-auto mb-4" id="Question" value={val?.Question || ''} onChange={(e)=>OnChange(e,index,'Question')} />
                                   
                                        {
                                            validateError?.['Question'+index] && <span className="text-danger">{validateError?.['Question'+index]}</span>
                                        }
                                    </Form>
                                    <SunEditor height={200} defaultValue={FaqAnswer[index]?.Answer || ''} id="Answer" onChange={(e)=>OnChange(e,index,'Answer')} />
                                    {
                                        validateError?.['Answer'+index] && <span className={"text-danger"}>{validateError?.['Answer'+index]}</span>
                                    }
                                    <div className='text-end mt-3'>
                                   <button className='btn btn-danger btn-sm ' onClick={()=>RemoveFaq(index)} type='button'>
                                    <FaTrash />
                                    </button></div>
                                    </div>
                                </>
                            )
                            }
                        )
                        :
                        <></>
                    }
                    
                    <button type="button" className="btn sitebtn py-2 px-3 mt-4" onClick={updateData}>Add</button>
                </div>
            </div>
        </Layout>
    )
}

export default ResourceUpdate;